'use client'
import { motion, type Variants } from 'framer-motion'

const heroTextVariants: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15, delayChildren: 0.3 } },
}
const itemVariants: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
}

export function HeroSection() {
  return (
    <section className="hero-section relative h-dvh overflow-hidden bg-[color:var(--bg-base)]">
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        src="/videos/hero-cinematic.mp4"
        poster="/images/hero-poster.png"
        className="absolute inset-0 w-full h-full object-cover opacity-70"
        aria-hidden="true"
      />

      {/* Base overlay for consistent text contrast */}
      <div className="absolute inset-0 pointer-events-none bg-[#0f172a]/40" />
      {/* Vignette for cinematic depth */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at center, transparent 40%, rgba(15,23,42,0.65) 100%)',
        }}
      />

      <motion.div
        className="absolute inset-0 z-10 flex flex-col items-center justify-center page-container text-center gap-6 py-24 pointer-events-none"
        variants={heroTextVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.p variants={itemVariants} className="text-sm font-semibold tracking-widest uppercase text-[color:var(--accent)] opacity-80">
          DOT# 3837801 — Authorized Property Carrier
        </motion.p>

        <motion.h1 variants={itemVariants} className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight tracking-tight max-w-4xl">
          Built for Speed.{' '}
          <span className="text-[color:var(--accent)]">Trusted by Brokers.</span>
        </motion.h1>

        <motion.p variants={itemVariants} className="text-lg md:text-xl text-[color:var(--foreground-muted)] max-w-2xl leading-relaxed">
          Dry Van, Reefer, and Power Only loads across the Northeast and beyond.
          Volvo and Freightliner equipment — New Jersey–based, coast-to-coast ready.
        </motion.p>

        <motion.div variants={itemVariants} className="flex flex-col sm:flex-row items-center gap-4 mt-4 pointer-events-auto">
          <a href="#quote" className="glass-button px-8 py-4 text-base font-semibold rounded-xl min-w-[180px] text-center">
            Request Quote
          </a>
          <a href="#broker-gateway" className="glass-button px-8 py-4 text-base font-semibold rounded-xl min-w-[180px] text-center">
            Broker Portal
          </a>
        </motion.div>
      </motion.div>
    </section>
  )
}
